import React from "react";

const Filed = ({style, text}) => {
  return (
    <div className={`text-center font-semibold min-w-32 border-r border-b border-black ${style}`}>
      {text}
    </div>
  )
}

export default Filed;